import { CameraCalibration, RawGondolasResponse } from "@/shared/api";
import { insightsApiInstance } from "@/shared/api/axios";

export function buildCameraImageMap(gondolas: RawGondolasResponse | undefined) {
  const imageMap = new Map<string, string>();

  if (!gondolas) return imageMap;

  for (const gondola of gondolas.results) {
    for (const camera of gondola.cameras) {
      imageMap.set(
        camera.camera_id,
        `${insightsApiInstance.defaults.baseURL}/store_images/${camera.image_webp}`
      );
    }
  }

  return imageMap;
}

export function getFilteredCameraIds({
  cameraType,
  selectedGondolas,
  cameraCalibrations,
  gondolas,
}: {
  gondolas: RawGondolasResponse;
  cameraType: string;
  selectedGondolas: string[];
  cameraCalibrations?: CameraCalibration[];
}) {
  if (cameraType === "non-shelf") {
    if (!cameraCalibrations) return [];
    return cameraCalibrations
      .filter((camera) =>
        gondolas.results.every((gondola) =>
          gondola.cameras.every(
            (gondolaCamera) => gondolaCamera.camera_id !== camera.camera_id
          )
        )
      )
      .map((camera) => camera.camera_id);
  }

  if (selectedGondolas.length === 0 && cameraType === "all") {
    return [];
  }

  const filteredGondolas =
    selectedGondolas.length === 0
      ? gondolas.results
      : gondolas.results.filter((gondola) =>
          selectedGondolas.includes(gondola.name)
        );

  const gondolaCameras = filteredGondolas.flatMap((gondola) => gondola.cameras);
  return gondolaCameras
    .filter(
      (camera) => cameraType === "all" || cameraType === camera.camera_type
    )
    .map((camera) => camera.camera_id);
}
